import { THERMAL_ZONE_STATUS, HVAC_MODE } from '../../config/status';

import './TempSettingsLockup.scss';

interface TempSettingsLockupProps {
  status: (typeof THERMAL_ZONE_STATUS)[keyof typeof THERMAL_ZONE_STATUS];
  temperature?: number;
  tempBounds?: { min: number; max: number };
  hvacMode?: (typeof HVAC_MODE)[keyof typeof HVAC_MODE];
  noBgColor?: boolean;
  size?: 'small' | 'large';
}

export const TempSettingsLockup = ({
  status,
  temperature,
  tempBounds,
  hvacMode,
  noBgColor = false,
  size = 'large',
}: TempSettingsLockupProps) => {
  // if (!status) {
  //   return null; // Don't render if status is not provided
  // }

  const isOffline = status?.key === THERMAL_ZONE_STATUS.OFFLINE.key;

  const renderTemperature = () => {
    let tempDisplay = '---';
    if (temperature !== undefined && temperature !== null) {
      tempDisplay = `${temperature}°`;
    }
    if (isOffline || typeof temperature !== 'number') {
      tempDisplay = `N/A`;
    }
    return <div className="temperature">{tempDisplay}</div>;
  };

  const renderRange = () => {
    if (isOffline) {
      return <div className="range offline">offline</div>;
    }
    let tempBoundsDisplay = '';
    if (tempBounds && tempBounds.min !== -146 && tempBounds.max !== -146) {
      if (tempBounds.min === tempBounds.max) {
        if (tempBounds.min === null) {
          tempBoundsDisplay = '---';
        } else {
          tempBoundsDisplay = `${tempBounds.min}°`;
        }
      } else {
        tempBoundsDisplay = `${tempBounds.min}° - ${tempBounds.max}°`;
      }
    }
    return <div className="range">{tempBoundsDisplay}</div>;
  };

  const renderSetting = () => {
    if (hvacMode) {
      return <div className={`setting ${hvacMode.key}`}>{hvacMode.label}</div>;
    }
    return null;
  };

  const renderRangeSettingBlock = () => {
    if (isOffline) return;
    if (tempBounds || hvacMode) {
      return (
        <div className="range-setting-block">
          {renderRange()}
          {renderSetting()}
        </div>
      );
    }
    return null;
  };

  return (
    <div className={`temperature-settings-lockup ${size}`}>
      <div
        className={`zone-thermostat-container ${status && status.cssClass && !noBgColor ? status.cssClass : ''}`}
      >
        <div
          className={`status-color-indicator ${status && status?.cssClass ? status.cssClass : ''}`}
        />
        {renderTemperature()}
        {renderRangeSettingBlock()}
      </div>
    </div>
  );
};
